import SituationBlock from './SituationBlock.jsx';
import PreparedOutputBlock from './PreparedOutputBlock.jsx';
import { DetailSections, WorkflowTraceList } from '../shared/index.js';

/**
 * HTL / Client Continuation detail body: what the agent prepared, in full, so
 * the reviewer can approve, edit, or block without navigating away. Content only
 * — the decision bar (Approve/Edit/Block) is rendered by ContinuationDecision in
 * the sticky footer (see EventDecision/decisionRegistry).
 *
 * Sections are hairline-separated like the prototype. They are collected first so
 * an absent block never leaves a stray divider behind.
 */
function ContinuationBody({ event }) {
  const detail = event.detail ?? {};

  const sections = [
    <SituationBlock key="situation" detail={detail} situation={event.situation} />,
    detail.output ? <PreparedOutputBlock key="output" detail={detail} /> : null,
    detail.trace?.length ? (
      <WorkflowTraceList
        key="trace"
        steps={detail.trace}
        reference={detail.traceRef}
        title={detail.workflow}
      />
    ) : null,
  ].filter(Boolean);

  return <DetailSections sections={sections} />;
}

export default ContinuationBody;
